import computed from './attrs/computed'
import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import {VueEditor} from 'vue2-editor'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import PagarmeRecipient from '../../../../components/PagarmeRecipient/Index'
import PagarmeKycLinkGenerator from '../../../../components/PagarmeKycLinkGenerator/Index'

export default {
    name: 'AgencyProfile',
    computed,
    created,
    data,
    methods,
    components: {
        PagarmeRecipient,
        PagarmeKycLinkGenerator,
        VueEditor,
        Cropper
    }
}
